<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-order
					v-model="filter"
					:outlets="outlets"
					:customers="customers"
					@filter="onFilter()"
				></filter-order>
			</v-flex>
			<!-- <v-flex md12 md2>
				<TenantOrderMenu></TenantOrderMenu>
			</v-flex> -->
			<v-flex xs12 md12>
				<v-layout row wrap>
					<v-flex xs12>
						<app-datatable
							printItem
							:title="$t('title.orders_datatable')"
							:printUrl="
								$route('central.print.orders', {
									params: {
										'filter[status]': this.filter.status,
									},
								})
							"
							:exportUrl="$route('central.export.orders')"
							:endpoint="endpoint"
							:data="data"
							:headers="headers"
							:filter="filter"
							@onPrint="printItem"
							@onView="viewItem"
							:hasView="true"
							:hasDelete="false"
							:hasPrint="false"
							:hasEdit="false"
						>
							<template v-slot:[`item.subtotal`]="{ item }">
								{{ item.subtotal | currency }}
							</template>
							<template v-slot:[`item.discount`]="{ item }">
								{{ item.discount | currency }}
							</template>
							<template v-slot:[`item.total`]="{ item }">
								{{ item.total | currency }}
							</template>
							<template v-slot:[`item.paid`]="{ item }">
								<app-payment-status-button
									v-model="item.paid"
									block
								></app-payment-status-button>
							</template>
						</app-datatable>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import moment from "moment";
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
import TenantOrderMenu from "@Shop/components/TenantOrderMenu.vue";
export default {
	remember: {
		data: ["filter"],
	},
	components: {
		Link,
		TenantOrderMenu,
	},
	props: ["data", "customers", "outlets"],
	data() {
		return {
			filter: {
				range: {
					startDate: new moment().format("YYYY-MM-DD"),
					endDate: new moment().format("YYYY-MM-DD"),
				},
			},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.orders.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "start",
					width: 80,
				},

				{
					text: this.$t("Code"),
					value: "code",
					sortable: false,
					searchable: false,
					width: 120,
				},

				{
					text: this.$t("Date"),
					value: "date",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Time"),
					value: "time",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Customer"),
					value: "customer_name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Outlet"),
					value: "outlet_name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Payment Method"),
					value: "payment_method_code",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Subtotal"),
					value: "subtotal",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Discount"),
					value: "discount",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Total"),
					value: "total",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Paid"),
					value: "paid",
					sortable: false,
					searchable: false,
				},
			];
		},
	},
	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		viewItem(item) {
			this.$inertia.get(this.$route("central.orders.show", item.uuid));
		},
		printItem(item) {
			window.open(
				this.$route("tenant.order.print", {
					tenant: this.$page.props.tenant.id,
					order: item.uuid,
				})
			);
		},
	},
};
</script>